import { readonly, reactive } from 'vue'

const state = reactive({
  brand: {
    part1: 'zero',
    part2: 'point',
    part3: 'maths',
    email1: 'Leo',
    email2: 'Maths',
    email3: 'Tuition',
    caption: 'Leo Maths tuition',
    levels: 'A Levels | BSc. Engineering',
    email: 'LeoMathsTuition@gmail.com',
    domain: '@gmail.com',
    mail_to: 'mailto:LeoMathsTuition@gmail.com?subject=Regarding Maths tuition...',
  },

  hero: {
    title: `
    Maths Made Simple
    `,
    subtitle1: `
    Friendly, focused higher-level maths tuition for A-Level and BSc Engineering
    `,
    subtitle2: `
    at student-friendly prices
    `,
    para: `Inspired by the physics concept of zero-point energy — where even systems at rest contain hidden potential — ZeroPointMaths helps students unlock their potential in Mathematics.`
  },

  features: {
    grouplive: 'Group Live Tuition',
    freefirst: 'Free 1st class',
    nocontract: 'no contract',
    noupfront: 'no upfront fee',
    fee: '£5 per session',
    duration45: '45-min live teaching',
    duration15: '+ 15-min guided discussion',
    corenum: 'Two',
    coreclass: 'weekly core classes',
    flexible: 'with flexible catch-up included if missed',
  },

  tutor: {
    name: 'Leo (B.Engg., M.Sc.)',
    pg: 'Masters - City, University of London',
    about: `
    ZeroPointMaths provides expert Maths tuition for GCSE, AS Level, A Level, and University students.
    `,
  },

  fee: {
    bankname: 'Barclays',
    accname: 'Santosh Singh',
    accnum: '3330 7220',
    sortcode: '20-76-90',
    paypal: 'https://www.paypal.me/MathsHour',
  },

  timetable: [
    // {
    //   name: 'GCSE Maths Higher',
    //   level: 'GCSE Maths Higher',
    //   thumbnails: ['gcse_higher_studentbook1.jpg', 'gcse_higher_studentbook2.jpg'],
    //   mon: '7am',
    //   tue: '7am',
    //   wed: '7am',
    //   thu: '7am',
    //   fri: '7am',
    //   sat: '7am',
    //   sun: '',
    // },
    // {
    //   name: 'GCSE Maths Foundation',
    //   level: 'GCSE Maths Foundation',
    //   thumbnails: ['gcse_foundation_studentbook1.jpg', 'gcse_foundation_studentbook2.jpg'],
    //   mon: '',
    //   tue: '',
    //   wed: '7am',
    //   thu: '7am',
    //   fri: '',
    //   sat: '',
    //   sun: '',
    // },
    {
      name: 'AS-level Maths',
      level: 'Year 1/AS',
      thumbnails: ['applied1.jpg'],
      mon: '6am',
      tue: '6am',
      wed: '6am',
      thu: '6am',
      fri: '6am',
      sat: '6am',
      sun: '',
    },
    {
      name: 'AS-level Maths',
      level: 'Year 1/AS',
      thumbnails: ['pure1.jpg'],
      mon: '7am',
      tue: '7am',
      wed: '7am',
      thu: '7am',
      fri: '7am',
      sat: '7am',
      sun: '',
    },
    {
      name: 'A-level Maths',
      level: 'Year 2 A-level',
      thumbnails: ['applied2.jpg'],
      mon: '7pm',
      tue: '7pm',
      wed: '7pm',
      thu: '7pm',
      fri: '7pm',
      sat: '7pm',
      sun: '',
    },
    {
      name: 'A-level Maths',
      level: 'Year 2 A-level',
      thumbnails: ['pure2.jpg'],
      mon: '8pm',
      tue: '8pm',
      wed: '8pm',
      thu: '8pm',
      fri: '8pm',
      sat: '8pm',
      sun: '',
    },
    {
      name: 'Engineering Maths',
      level: 'BSc. Engineering',
      // thumbnails: ['stroud_booth.jpg', 'james_dyke.jpg'],
      thumbnails: ['stroud_booth.jpg'],
      mon: '9pm',
      tue: '9pm',
      wed: '',
      thu: '',
      fri: '',
      sat: '',
      sun: '',
    },
    {
      name: 'Advanced Engineering Maths',
      level: 'BSc. Engineering',
      // thumbnails: ['stroud_booth_adv.jpg', 'james_dyke_adv.jpg'],
      thumbnails: ['stroud_booth_adv.jpg'],
      mon: '',
      tue: '',
      wed: '9pm',
      thu: '9pm',
      fri: '9pm',
      sat: '9pm',
      sun: '',
    }
  ],
})

const methods = {
  onLoad() {
    console.log('courses loaded')
  },
}

const getters = {

}

export default {
  state: readonly(state),
  methods,
  getters,
}